export default {
  isAuthenticated (state) {
    if (state) {
      let result = state.id !== null && state.id !== undefined
      return result
    } else {
      return false
    }
  },
  isVerified (state) {
    return state.emailVerified || false
  },
  unsavedData (state) {
    return state.unsavedData || false
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user/getters.js